import { useSearchParams } from "react-router-dom";
import useFetch from "../../../hooks/useFetch";
import { classNames } from "../../../helpers/classNames";
import Image from "../../../components/elements/Image";
import Quiltext from "../../../components/elements/Quiltext";
import Progress from "../../../components/elements/Progress";
import { projectDetails } from "../../../services/projectService";

const ProjectsItem = () => {
  const [searchParams] = useSearchParams();
  const idFromUrl = searchParams.get("projectId");

  const { data, updateData, isFetching, refetch } = useFetch({
    dependencies: ["bannerDtls", idFromUrl],
    fetchFunction: async () => {
      const res = await projectDetails({
        id: idFromUrl,
      });
      return res?.data;
    },
  });

  const projectData = {
    ...data,
    metas: [
      {
        _id: 1,
        label: "Goal",
        data: data?.goalAmount || 0,
      },
      {
        _id: 2,
        label: "Amount Raised",
        data: data?.raisedAmount || 0,
      },
      {
        _id: 3,
        label: "Progress",
        type: "progress",
        data:
          (
            (Number(data?.raisedAmount?.replace(/[^0-9.-]+/g, "") || 0) /
              Number(data?.goalAmount?.replace(/[^0-9.-]+/g, "")) || 0) * 100
          ).toFixed(1) || 0,
      },
    ],
  };

  return (
    <section
      id={`project-${projectData?._id}`}
      className={classNames("relative flex w-full py-16 bg-chestnut-rose/20")}
    >
      <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
        <div className={classNames("flex gap-16 flex-row")}>
          <div className="w-[45%] flex flex-shrink-0">
            <div className="w-full overflow-hidden">
              <Image
                src={projectData?.image?.url}
                alt={""}
                effect="blur"
                classes="object-cover"
              />
            </div>
          </div>
          <div className="w-[55%] flex-shrink flex-grow flex flex-col space-y-12 py-12">
            <div className="space-y-4">
              {projectData?.title && (
                <h2 className="text-3xl sm:text-4xl xls:text-[42px] font-bold">
                  {projectData?.title}
                </h2>
              )}
              {projectData?.location && (
                <div className="text-lg font-Gotham font-medium">
                  <i className="fa-regular fa-location-dot"></i>{" "}
                  {projectData?.location}
                </div>
              )}
              {projectData?.time && (
                <div className="font-CanelaDeck text-lg gap-x-2 flex items-center whitespace-nowrap">
                  <i className="text-2xl fa-regular fa-fw fa-clock"></i>{" "}
                  {projectData?.time?.start} - {projectData?.time?.end}
                </div>
              )}
            </div>
            {projectData?.description && (
              <div>
                <Quiltext description={projectData?.description} />
              </div>
            )}
            {projectData?.metas?.length > 0 && (
              <div className="flex py-6 px-6 bg-white rounded-2xl divide-x divide-shades-05/50">
                {projectData?.metas?.map((item, index) => (
                  <div
                    key={index}
                    className="flex flex-col gap-2 items-center justify-center flex-shrink flex-grow"
                  >
                    <div className="text-3xl font-CanelaDeck font-bold">
                      {item?.type === "progress" ? (
                        <Progress
                          progress={item?.data}
                          className={"w-28 h-28"}
                          strokeWidth={8}
                        />
                      ) : (
                        item?.data
                      )}
                    </div>
                    <div className="text-xl font-medium text-chestnut-rose">
                      {item?.label}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectsItem;
